import ReactDOM from "react-dom";
import BaseComponent from "./BaseComponent";
import LocaleTextarea from "./LocaleTextarea";

export default class LocalModuleNodeGroup extends BaseComponent {
  constructor(props) {
    super(props);
    this.dataCache = {
      version: this.props.mod.version,
      mod: this.props.mod
    }
    this.state={
      mod: this.props.mod,
      prompts: this.props.prompts,
      channelLayer: this.props.channelLayer,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.channelLayer !== this.props.channelLayer) {
      this.setState({ channelLayer: this.props.channelLayer });
    }
  }
  
  validateInput({ currentTarget }) {
    return currentTarget.value !== '';
  }

  getDomSelf() {
    return $(ReactDOM.findDOMNode(this));
  }

  setConfig(key, newValue) {
    if (key === "version") {
      this.dataCache[key] = newValue;
    }
    if (key === "prompt") {
      const { lang, value, idx, channelLayer } = newValue;
      const { isOmniChannel } = window.apm.serialized.omniChannel;
      const updatedMod = this.state.mod;
      const flowNode = updatedMod.versions[this.getConfig("version")].flow.nodes[idx];

      if(!flowNode) return 
      
      if(isOmniChannel) {
        flowNode.props.config.channel[channelLayer] ??= _.cloneDeep(this.props.context.emptyLangsObject);
        flowNode.props.config.channel[channelLayer][lang] = value;
      } else {
        flowNode.props.config.text[lang] = value;
      }
      
      flowNode.props.lastLocalChange = window.apm.timestamp;
      //update the components object and all the modules it is used in
      window.apm.updateParentNode(flowNode, flowNode.props.parentComponentID, "channel", flowNode.props.config.channel, "object");

      this.setState({ mod: updatedMod });
      this.setState({ prompts: this.props.context.getPromptNodes(updatedMod) });
    }
    window.apm.setSerializedChanged();
    window.apm.postEventToCurrentView({ target: "request-refresh" });
    window.apm.reactDOMComponents.render({ name: 'SettingWidget', props: { serialized: window.apm.serialized }, $el: $('#settings') });
  }

  componentWillReceiveProps(nextProps){   
     this.setState({mod: nextProps.mod})
  }

  getConfig(key) {
    if (key === "version" || key === "mod") {
      return this.dataCache[key];
    }
  }
  
  render() {
    const versions = [];
    for (var ver in this.state.mod.versions) {
      if (!this.state.mod.versions.hasOwnProperty(ver)) {
        continue;
      }
      versions.push({ name: this.getPropLabel("version") + ver, value: ver });
    }
    var engSel = window.apm.knowledgeBase.getItemFromValue("en-US", window.apm.serialized.languages, "language");
    const engSelDupe = this.props.language !== "en-US";

    return (
      <div className="panel-group" role="tablist">
        <div className="panel panel-default">
          <div className="panel-heading" role="tab" style={{ padding: "0", paddingLeft: "15px" }}>
            <div className={"row"}>
              <div className={"col-md-10"} style={{ padding: "10px" }}>
                <div className="panel-title"
                  onClick={() => {
                    this.getDomSelf().find(".collapse[data-tracker='" + this.state.mod.id + "']").collapse('toggle');
                  }}
                >
                  <i className={"fe icon-" + (this.state.mod.props.iconClass ? this.state.mod.props.iconClass : "package")} />
                  &nbsp;&nbsp;{this.state.mod.name}
                </div>
              </div>
            </div>
          </div>
          <div className="panel-collapse collapse in" role="tabpanel" data-tracker={this.state.mod.id}>
            <div className="panel-body">
              <div className="row">
                <table className={"table table-condensed"}>
                  <thead>
                    <tr style={{ color: "var(--color-text-lightest)", fontSize: "14px" }}>
                      <td style={{ width: "20%" }}>{window.l.settings.prompt_node_name}</td>
                      <td style={{ width: "40%" }}>English - {engSel.voice}</td>
                      {engSelDupe && <td style={{ width: "40%" }}>{this.props.language} - {this.props.voice}</td>}
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      // vfn stands for Versions Flow Nodes
                      const vfn = this.state.prompts;
                      const { isOmniChannel } = window.apm.serialized.omniChannel;

                      if (!vfn.length) {
                        return [];
                      }

                      var nodes = [];

                      for (var j = 0; j < vfn.length; j++) {
                        const prompt = vfn[j];

                        if (prompt._class !== "PromptNodeModel") {
                          continue;
                        }

                        const isCommonModulePrompt = prompt.props.isCommonModule;
                        const promptChannelLayer = this.state.channelLayer;

                        const nodeIndex = this.state.mod.versions[1].flow.nodes.findIndex(n => n.id === vfn[j].id)
                        const parentIndex = window.apm.getAttachments("object").findIndex(ob => ob.id === vfn[j].id && ob.props.nodeTypeName === "Prompt");

                        if (nodeIndex === -1 && parentIndex === -1) {
                          continue;
                        }

                        const defaultEnglishText = ((isOmniChannel && !isCommonModulePrompt) ? prompt.props.config.channel[promptChannelLayer]?.['en-US'] : prompt.props.config.text["en-US"]) || "";

                        const defaultOtherLanguageText = ((isOmniChannel && !isCommonModulePrompt) ? prompt.props.config.channel[promptChannelLayer]?.[this.props.language] : prompt.props.config.text[this.props.language]) || "";
                        const index = nodeIndex !== -1 ? nodeIndex : parentIndex;
                        const parentComponentID = nodeIndex !== -1 ? this.state.mod.versions[1].flow.nodes[nodeIndex].props.parentComponentID : window.apm.getAttachments("object")[parentIndex].id;

                        nodes.push(
                          <tr key={prompt.id}>
                            <td>
                              <label>{prompt.name !== "" ? prompt.name : "Name is Empty"}</label>
                              {isOmniChannel && <p style={{ color: 'var(--color-text-lightest)' }}>Channel: {promptChannelLayer} </p>}
                            </td>
                            <td>
                              <LocaleTextarea
                                rowsVal={4}
                                defaultValue={defaultEnglishText}
                                valKey={"prompt"}
                                idx={index}
                                channelLayer={promptChannelLayer}
                                context={this}
                                type={"prompt"}
                                parentComponentID={parentComponentID}
                                language={this.props.language}
                                isEnUS={true}
                              />
                            </td>
                            <td>
                              {this.props.language !== "en-US" &&
                                <LocaleTextarea
                                  rowsVal={4}
                                  defaultValue={defaultOtherLanguageText}
                                  valKey={"prompt"}
                                  channelLayer={promptChannelLayer}
                                  idx={index}
                                  context={this}
                                  type={"prompt"}
                                  parentComponentID={parentComponentID}
                                  language={this.props.language}
                                  isEnUS={false}
                                />
                              }
                              {this.props.language === "en-US" && engSelDupe &&
                                <LocaleTextarea
                                  rowsVal={4}
                                  defaultValue={prompt.props.config.text[this.props.language] || ""}
                                  valKey={"prompt"}
                                  idx={index}
                                  context={this}
                                  type={"prompt"}
                                  parentComponentID={parentComponentID}
                                  language={this.props.language}
                                  isEnUS={true}
                                />
                              }
                            </td>
                          </tr>
                        );
                      }

                      return nodes;
                    })()}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
